import React from "react";
import {
  FaVimeoV,
  FaInstagram,
  FaTwitter,
  FaPinterestP,
  FaFacebookF,
  FaSearch
} from "react-icons/fa";

import "./Footer.css";

function Footer() {
  return (
    <>
      {/* ===========================
                FOOTER
      =========================== */}

      <footer
        className="cc-footer"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1519501025264-65ba15a82390?auto=format&fit=crop&w=1920&q=80')",
        }}
      >
        <div className="cc-footer-overlay">

          <div className="cc-footer-top">

            {/* LEFT SOCIAL */}

            <div className="cc-footer-social">

              <a href="/">
                <FaVimeoV />
              </a>

              <a href="/">
                 <FaInstagram />
              </a>

  <a href="/">
    <FaTwitter />
  </a>

  <a href="/">
    <FaPinterestP />
  </a>

  <a href="/">
    <FaFacebookF />
  </a>

</div>

            {/* LOGO */}

            <div className="cc-footer-logo">

              <h1>
                Interior 
                <span>Mart</span>
              </h1>

            </div>

            {/* SEARCH */}

            <div className="cc-footer-search">

              <FaSearch className="cc-footer-search-icon" />

              <input
                type="text"
                placeholder="SEARCH"
              />

            </div>

          </div>

          {/* COPYRIGHT */}

          <div className="cc-footer-bottom">

            <p>
              © 2026 InteriorMart.
              <br />

              Designed & Developed by

              <span>
                {" "}
                CallTech Global Team ( A Brand of M.Star Services )
              </span>

            </p>

          </div>

        </div>

      </footer>
    </>
  );
}

export default Footer;